<template>
  <div>
    <el-dialog
      id="app"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="new-bill-payment-dialog"
      :visible="visible"
      :title="$t('CargoMsg.Cargo_CreatePaymentRequestChooseFees')"
      width="1100px"
      append-to-body
      top="5vh"
      @close="cancel"
    >
      <div class="app-main-inner-row  extension-conditions-form" style="background: #f5f7f7; padding: 5px 16px 0 16px !important;">
        <div>
          <template style="display: flex">
            <span>{{ $t('Payment.inquiryWay') }}</span>
            <el-radio-group v-model="queryType" no="1" @change="changeQueryType">
              <el-radio :label="1">{{ $t('Payment.accordingToCharge') }}</el-radio>
              <el-radio :label="2">{{ $t('Payment.accordingToBusiness') }}</el-radio>
            </el-radio-group>
            <el-checkbox v-model="defaultSearchConditions.isAr" no="2" :true-label="0" :false-label="-1" style="margin-left: 5px;">{{ $t('Payment.includeReceivables') }}</el-checkbox>
            <span style="color: #ff0000;margin-left: 5px;">{{ $t('Payment.couldNotSearhWriteOffJobFromThisWindow') }}</span>
          </template>
        </div>
      </div>
      <div
        class="app-main-inner-row"
        style="padding-bottom: 10px;flex-direction: column"
      >
        <search-item
          v-if="showByChargeList"
          :key="1"
          ref="searchItem"
          :visible.sync="showByChargeList"
          :show-more-scheme="true"
          :show-simple="false"
          :expand-adv="true"
          :col-settings="{span:12}"
          :append-to-body="true"
          search-item-code="创建付款申请-加入费用"
          config-module="5082"
          @advSearchItemCallBack="fetchData"
        />
        <search-item
          v-if="showByJobList"
          :key="2"
          ref="searchItem"
          :visible.sync="showByJobList"
          :show-more-scheme="false"
          :show-simple="false"
          :expand-adv="true"
          :col-settings="{span:12}"
          :append-to-body="true"
          search-item-code="创建付款申请-加入费用"
          config-module="5083"
          @advSearchItemCallBack="fetchData"
        />
        <div
          v-if="showByChargeList"
          class="app-main-inner-row row-grid"
          style="flex:1;height:300px"
        >
          <cargo-ag-grid
            config-module="508201"
            :grid-options="gridOptions"
            :grid-params="gridParams"
            :column-defs="ChargeColumnDefs"
            :row-data="ChargeRowData"
            :style="{width:'100%',height:'300px'}"
          />
        </div>
        <div
          v-if="showByJobList"
          class="app-main-inner-row row-grid"
          style="flex:1;height:300px"
        >
          <cargo-ag-grid
            config-module="508202"
            :grid-options="gridOptions"
            :grid-params="gridParams"
            :column-defs="JobChargecolumnDefs"
            :row-data="JobChargeRowData"
            :style="{width:'100%',height:'300px'}"
          />
        </div>
        <cargo-pagination
          v-if="showByChargeList"
          key="charge"
          :page-sizes="[5,6,7,8,10,20,30,50,100,500]"
          :total="searchConditions.charge.total"
          :page.sync="searchConditions.charge.pageNum"
          :limit.sync="searchConditions.charge.pageSize"
          @pagination="fetchDataByPage"
        />
        <cargo-pagination
          v-if="showByJobList"
          key="job"
          :page-sizes="[5,6,7,8,10,20,30,50,100,500]"
          :total="searchConditions.job.total"
          :page.sync="searchConditions.job.pageNum"
          :limit.sync="searchConditions.job.pageSize"
          @pagination="fetchDataByPage"
        />
      </div>
      <div slot="footer">
        <el-button
          no="3"
          type="primary"
          size="mini"
          @click="nextStep"
        >{{ $t('Payment.next') }}</el-button>
        <el-button
          no="4"
          size="mini"
          @click="cancel"
        >{{ $t('Payment.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'

import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import { getGridSelected } from '@/utils/agGrid'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import { getAddChargeList } from '@/api/clearing/billingNative'
import { queryJobPageableFast } from '@/api/clearing/billPayment.js'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import * as index from '@/utils/index'
import CustomLableUtils from '@/utils/CustomLabelUtils'

export default {
  name: 'NewBillPaymentDialog',
  components: { searchItem },
  props: {
    viewSource: { type: String, required: true }, // 来自新增费用/还是新增付款申请
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    billPaymentUuid: { type: String, required: false },
    billPaymentAccountId: { type: Number, required: false },
    defaultConditions: { type: Object, required: true } // 弹框打开时默认传递条件
  },
  data() {
    return {
      // 1按费用查询 2按业务查询
      queryType: 1,
      showByChargeList: true,
      showByJobList: false,
      gridOptions: {
        rowSelection: 'multiple'
      },
      gridParams: {},
      gridApi: {},
      ChargeColumnDefs: [],
      JobChargecolumnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      ChargeRowData: [],
      JobChargeRowData: [],
      searchConditions: {
        charge: {
          total: 0, // total传递到后端无用
          pageNum: 1,
          pageSize: 10
        },
        job: {
          total: 0, // total传递到后端无用
          pageNum: 1,
          pageSize: 10
        },
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      defaultSearchConditions: {
        isAr: -1, // 应收/应付
        advance: -1, //  是否垫付
        oversea: this.defaultConditions.oversea, // （国内/国外）
        hasInvoice: -1, // 是否开票
        hasDiffCharge: -1, // 是否关联差异对冲费用
        jobStates: [], // 业务状态
        chargeStates: [], // 费用状态
        confirmStates: [], // 费用确认状态
        exceptKeys: this.defaultConditions.exceptKeys, // 在查询中想要例外的对象列表
        hasBillPayment: -1, // 是否关联付款申请
        hasBilling: this.defaultConditions.hasBilling, // 是否关联账单
        paidOff: 0 // 是包含以核销
      },
      queryChargeForJobConditions: [] // 业务查询高级查询暂存
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    }
  },
  watch: {
    visible(val) {
      if (val) {
        if (this.viewSource === 'tabBilling') { // 根据账单创建付款申请
          if (this.defaultConditions.hasOwnProperty('billingKeys')) {
            const conditions = []
            const condition = new AdvancedSearchOption(null, 'billing.UUID', this.defaultConditions.billingKeys, OperatorConstants.OPERATOR_IN.code)
            conditions.push(condition.formatObj2Json())
            this.toAdvQueryList(conditions)
          }
        }
      }
    }
  },
  mounted() {
    // 按费用查询列显示
    this.ChargeColumnDefs = [
      {
        headerName: '', checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200 },
      { headerName: this.$t('Payment.warehouseNo'), field: 'jobWarehouseNo', width: 200 },
      { headerName: this.$t('Payment.bookingNo'), field: 'jobBookingNo', width: 200 },
      { headerName: this.$t('SeaExport.DocCutOffDate'), field: 'jobFileCutoff', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.itemNo'), field: 'jobPoNo', width: 200 },
      { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 200,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          tag: 'so-no-render',
          attrs: {
            divider: '\n'
          }
        }
      },
      { headerName: this.$t('Payment.containerNo'), field: 'jobContainerNo', width: 200 },
      { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.billPaymentNo'), field: 'billPaymentBillPaymentNo', width: 200 },
      { headerName: this.$t('Payment.eta'), field: 'jobEta', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.etd'), field: 'jobEtd', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.atd'), field: 'jobAtd', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.ata'), field: 'jobAta', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.billNo'), field: 'billingBillingNo', width: 200 },
      { headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.cargoSourceLabelFunction(params.value)
        } },
      { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
      { headerName: this.$t('Payment.separateNumber'), field: 'jobImportHbl', width: 200 },
      { headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.businessType'), field: 'jobLob', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.jobBussStateLabelFunc(params.value)
        } },
      { headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVesselFlight', width: 200 },
      { headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
        } },
      { headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
        } },
      { headerName: this.$t('SeaExport.departureStation'), field: 'jobDepartureStation', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
        } },
      { headerName: this.$t('SeaExport.destinationStation'), field: 'jobDestinationStation', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
        } },
      { headerName: this.$t('SeaExport.transitStation'), field: 'jobTransitStation', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
        } },
      { headerName: this.$t('Payment.destinationAgent'), field: 'jobDestinationAgent', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.sales'), field: 'jobSales', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.operation'), field: 'jobOp', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.customerService'), field: 'jobCsr', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('SeaExport.Documents'), field: 'jobDc', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.businessReferenceNumber'), field: 'jobCustomerRefNo', width: 200 },
      { headerName: this.$t('Payment.customJobType'), field: 'jobCustomJobType', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CutomJobType, 'code', params.value, 'name')
        } },
      { headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        } },
      { headerName: this.$t('Payment.financialDate'), field: 'chargeAccountingDate', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.domesticInternational'), field: 'chargeOversea', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.overseaLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.isReceivable'), field: 'chargeReceivable', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(params.value)
        } },
      { headerName: this.$t('Payment.feeStatus'), field: 'chargeChargeState', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.chargeStateLabFun(params.value)
        } },
      { headerName: this.$t('Payment.auditor'), field: 'chargeAuditor', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.confirmationStatus'), field: 'chargeConfirmState', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.chargeConfirmStateLabFun(params.value)
        } },
      { headerName: this.$t('Payment.chargeItem'), field: 'chargeChargeItemId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
        } },
      { headerName: this.$t('Payment.unit'), field: 'chargeMeasure', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.measureLabelFunction(params.value)
        }
      },
      { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 200 },
      { headerName: this.$t('Payment.quantity'), field: 'chargeQuantity', width: 200 },
      { headerName: this.$t('Payment.unitPrice'), field: 'chargeUnitRate', width: 200,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        }
      },
      { headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmount', width: 200,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        }
      },
      { headerName: this.$t('Payment.taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 200,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        }
      },
      { headerName: this.$t('Payment.taxAmount'), field: 'chargeTaxAmount', width: 200,
        cellRenderer: (params) => {
          return params.value === 0 ? '' : NumberUtils.formatRoundNumber(params.value, 2)
        }
      },
      { headerName: this.$t('Payment.taxRate'), field: 'chargeTaxRate', width: 200,
        cellRenderer: (params) => {
          return params.value === 0 ? 0 : index.formatNumberToThousands(params.value, 2)
        }
      },
      { headerName: this.$t('Payment.theAmountOfWriteOffs'), field: 'chargeVerifiedAmount', width: 200,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        }
      },
      { headerName: this.$t('Payment.amountNotWrittenOff'), field: 'chargeUnverifiedAmount', width: 200,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        }
      },
      { headerName: this.$t('Payment.contactPerson'), field: 'chargeContactPerson', width: 150 },
      { headerName: this.$t('Payment.creator'), field: 'chargeCreatedBy', width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      {
        headerName: this.$t('Payment.dateOfCreation'), field: 'chargeDateCreated', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.remarks'), field: 'chargeRemarks', width: 200 },
      { headerName: this.$t('Payment.relatedJob'), field: 'jobRelatedJob', width: 200 },
      { headerName: this.$t('Payment.trustFromJob'), field: 'jobTrustFromJob', width: 200 },
      { headerName: this.$t('Payment.carrierId'), field: 'jobCarrierId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.confirmDate'), field: 'chargeConfirmDate', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.confirmUser'), field: 'chargeConfirmUser', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.planner'), field: 'jobPlanner', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.invoiceDateAll'), field: 'invoiceInvoiceDate', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.invoiceNo'), field: 'chargeInvoiceNo', width: 200 },
      { headerName: this.$t('Payment.invoiceHeader'), field: 'invoiceTitle', width: 200 },
      { headerName: this.$t('Payment.isNeedInvoice'), field: 'chargeNeedInvoice', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        } },
      { headerName: this.$t('Payment.confirmRemarks'), field: 'chargeConfirmRemarks', width: 200 },
      { headerName: this.$t('Payment.writeOffDate'), field: 'chargeClearingDate', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.businessStatus'), field: 'jobJobState', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.jobStateLabelFunc(params.value)
        } },
      { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200 },
      { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200 },
      { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200 },
      { headerName: this.$t('Payment.payReceiveDate'), field: 'chargePayReceiveDate', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('SeaExport.SalesDepartment'), field: 'jobSalesDepartment', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department, 'departmentId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.BookingAgent'),
        field: 'jobBookingAgent',
        colId: 'jobBookingAgent',
        hide: true,
        cellRenderer: (params) => {
          if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
            return ''
          }
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
        },
        initialWidth: 200
      },
      {
        headerName: this.$t('SeaExport.BillExchangeAgent'),
        field: 'exChangeAgent',
        colId: 'exChangeAgent',
        hide: true,
        cellRenderer: (params) => {
          if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
            return params.data.jobBookingAgent ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobBookingAgent, 'auto_1') : ''
          }
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
        },
        initialWidth: 200
      },
      {
        headerName: this.$t('SeaExport.CategoryOfGoods'),
        field: 'cargoCode',
        colId: 'cargoCode',
        cellRenderer: (params) => {
          return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
        },
        hide: true,
        width: 150
      }
    ]
    // 按业务查询列显示
    this.JobChargecolumnDefs = [
      {
        headerName: '', checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200 },
      { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
      { headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.carrierId'), field: 'jobCarrierId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 200,
        cellRendererFramework: 'agGridColumnEdit',
        custom: {
          tag: 'so-no-render',
          attrs: {
            divider: ' '
          }
        }
      },
      { headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.businessType'), field: 'jobLob', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.jobBussStateLabelFunc(params.value)
        } },
      { headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVesselFlight', width: 200 },
      { headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
        } },
      { headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
        } },
      { headerName: this.$t('Payment.operation'), field: 'jobOp', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.sales'), field: 'jobSales', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.booleanLabelFunction(params.value)
        } },
      { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 200 },
      { headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmounts', width: 200,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        }
      },
      { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200 },
      { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200 },
      { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200 },
      { headerName: this.$t('Payment.atd'), field: 'jobAtd', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.ata'), field: 'jobAta', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.BookingAgent'),
        field: 'jobBookingAgent',
        colId: 'jobBookingAgent',
        hide: true,
        cellRenderer: (params) => {
          if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
            return ''
          }
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
        },
        initialWidth: 200
      },
      {
        headerName: this.$t('SeaExport.BillExchangeAgent'),
        field: 'exChangeAgent',
        colId: 'exChangeAgent',
        hide: true,
        cellRenderer: (params) => {
          if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
            return params.data.jobBookingAgent ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobBookingAgent, 'auto_1') : ''
          }
          return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
        },
        initialWidth: 200
      },
      {
        headerName: this.$t('SeaExport.CategoryOfGoods'),
        field: 'cargoCode',
        colId: 'cargoCode',
        cellRenderer: (params) => {
          return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoInformation, 'code', params.value, 'chineseName') : ''
        },
        hide: true,
        width: 150
      }
    ]
  },
  beforeMount() {},
  methods: {
    cancel() {
      this.$emit('close', false)
    },
    fetchData(conditions) {
      this.searchConditions.snapshotConditions = [...conditions]
      this.searchConditions.charge.pageNum = 1
      this.searchConditions.job.pageNum = 1
      this.fetchDataByPage()
    },
    // 分页触发查询
    fetchDataByPage() {
      if (this.queryType === 1) {
        // 按费用查询
        this.toAdvQueryList(this.searchConditions.snapshotConditions)
      } else {
        // 按业务查询
        this.toAdvQueryListByJob(this.searchConditions.snapshotConditions)
      }
    },
    async toAdvQueryList(conditions) {
      this.loading = getLoading()
      // if(isSearchLog){
      //   var chargeSearchList:IList = (currentState == "advanced") ? searchCompantent.dataProvider
      //     : conditionGroup.dataProvider;
      //   insertSearchLog(modelCode, searchContent, chargeSearchList);
      // }
      // 结算类型中的"月结"是按照大于1来判断的，不能用等于
      for (let i = 0; i < conditions.length; i++) {
        const condition = conditions[i]
        if (condition.fieldType === 'FIELD_SETTLEMENT_TYPE' && condition.value === 1) {
          condition.operator = OperatorConstants.OPERATOR_GREATER.code
          break
        } else if (condition.fieldType === 'FIELD_SETTLEMENT_TYPE' && condition.value === -1) {
          conditions.splice(i, 1)
        }
      }
      const defaultSearchConditions = this.defaultSearchConditions
      // 应收/应付
      if (defaultSearchConditions.isAr === -1) {
        const condition = new AdvancedSearchOption(
          null,
          'charge.ACCOUNT_RECEIVABLE',
          false,
          OperatorConstants.OPERATOR_EQUAL.code
        )
        conditions.push(condition.formatObj2Json())
      }
      // 是否垫付
      if (defaultSearchConditions.advance !== -1) {
        const condition = new AdvancedSearchOption(
          null,
          'charge.ADVANCE',
          defaultSearchConditions.advance === 1,
          OperatorConstants.OPERATOR_EQUAL.code
        )
        conditions.push(condition.formatObj2Json())
      }
      // 国内/国外
      if (defaultSearchConditions.oversea > -1) {
        const condition = new AdvancedSearchOption(
          null,
          'charge.OVERSEA',
          defaultSearchConditions.advance === 1,
          OperatorConstants.OPERATOR_EQUAL.code
        )
        conditions.push(condition.formatObj2Json())
      }
      // 是否开票
      if (defaultSearchConditions.hasInvoice !== -1) {
        const operator =
          defaultSearchConditions.hasInvoice === 0
            ? OperatorConstants.OPERATOR_IS_NULL.code
            : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(
          null,
          'charge.INVOICE_UUID',
          null,
          operator
        )
        conditions.push(condition.formatObj2Json())
      }
      // 红冲状态
      conditions.push(
        new AdvancedSearchOption(
          null,
          'charge.OFFSET_STATE',
          0,
          OperatorConstants.OPERATOR_EQUAL.code
        ).formatObj2Json()
      )
      // 是否关联差异对冲费用
      if (defaultSearchConditions.hasDiffCharge !== -1) {
        const operator =
          defaultSearchConditions.hasDiffCharge === 0
            ? OperatorConstants.OPERATOR_IS_NULL.code
            : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        conditions.addItem(
          new AdvancedSearchOption(
            null,
            'charge.DIFF_CHARGE_UUID',
            null,
            operator
          )
        )
      }
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        let jobStates = []
        const billingJobState = await LoadDefaultQueryParam.getConfigQueryParam(
          'BillPaymentJobState',
          SystemConstants.JOB_STATES
        )
        if (billingJobState) {
          jobStates = LoadDefaultQueryParam.convertCommonStateToInt(
            billingJobState
          )
          const condition = new AdvancedSearchOption(
            null,
            'job.JOB_STATE',
            jobStates,
            OperatorConstants.OPERATOR_IN.code
          )
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用状态
      if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
        let chargeStates = []
        const billingChargeState = await LoadDefaultQueryParam.getConfigQueryParam(
          'BillPaymentChargeState',
          ChargeConstants.CHARGE_STATES
        )
        if (billingChargeState) {
          chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(
            billingChargeState
          )
          const condition = new AdvancedSearchOption(
            null,
            'charge.CHARGE_STATE',
            chargeStates,
            OperatorConstants.OPERATOR_IN.code
          )
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用确认状态
      if (!AdvancedSearchOption.hasField('charge.CONFIRM_STATE', conditions)) {
        let confirmStates = []
        const billingChargeConfirmState = await LoadDefaultQueryParam.getConfigQueryParam(
          'BillPaymentChargeConfirmState',
          ChargeConstants.CONFIRM_STATES
        )
        if (billingChargeConfirmState) {
          confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(
            billingChargeConfirmState
          )
          const condition = new AdvancedSearchOption(
            null,
            'charge.CONFIRM_STATE',
            confirmStates,
            OperatorConstants.OPERATOR_IN.code
          )
          conditions.push(condition.formatObj2Json())
        }
      }
      // 在查询中想要例外的对象列表
      if (defaultSearchConditions.exceptKeys.length > 0) {
        const condition = new AdvancedSearchOption(
          null,
          'charge.UUID',
          defaultSearchConditions.exceptKeys,
          OperatorConstants.OPERATOR_NOT_IN.code
        )
        conditions.push(condition.formatObj2Json())
      }
      // 是否做过付款申请
      if (defaultSearchConditions.hasBillPayment === -1) {
        const operator =
          defaultSearchConditions.hasBillPayment === -1
            ? OperatorConstants.OPERATOR_IS_NULL.code
            : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(
          null,
          'charge.BILL_PAYMENT_UUID',
          null,
          operator
        )
        conditions.push(condition.formatObj2Json())
      }
      // 是否做过账单
      if (defaultSearchConditions.hasBilling !== -1) {
        const operator =
          defaultSearchConditions.hasBilling === 0
            ? OperatorConstants.OPERATOR_IS_NULL.code
            : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(
          null,
          'charge.BILLING_UUID',
          null,
          operator
        )
        conditions.push(condition.formatObj2Json())
      }
      // 是否显示  0 不勾选 1勾选已核销
      if (this.defaultSearchConditions.paidOff !== -1) {
        const condition = new AdvancedSearchOption(
          null,
          'charge.PAID_OFF',
          0,
          OperatorConstants.OPERATOR_EQUAL.code
        )
        conditions.push(condition.formatObj2Json())
      }
      const requestBody = {
        conditions,
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.searchConditions.charge.pageNum,
        pageSize: this.searchConditions.charge.pageSize,
        requestSource: 'billPayment_Create_Charge'
      }
      getAddChargeList(requestBody)
        .then((res) => {
          this.ChargeRowData = res.data.list
          this.searchConditions.charge.total = Number(res.data.total)
        })
        .finally(() => {
          this.loading.close()
        })
    },
    // 按业务查询费用
    async toAdvQueryListByJob(conditions) {
      this.loading = getLoading()
      const defaultSearchConditions = this.defaultSearchConditions
      // 红冲状态
      conditions.push(
        new AdvancedSearchOption(
          null,
          'charge.OFFSET_STATE',
          0,
          OperatorConstants.OPERATOR_EQUAL.code
        ).formatObj2Json()
      )
      // 业务状态
      if (!AdvancedSearchOption.hasField('job.JOB_STATE', conditions)) {
        let jobStates = []
        const billingJobState = await LoadDefaultQueryParam.getConfigQueryParam(
          'BillingJobState',
          SystemConstants.JOB_STATES
        )
        if (billingJobState) {
          jobStates = LoadDefaultQueryParam.convertCommonStateToInt(
            billingJobState
          )
          const condition = new AdvancedSearchOption(
            null,
            'job.JOB_STATE',
            jobStates,
            OperatorConstants.OPERATOR_IN.code
          )
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用状态
      if (!AdvancedSearchOption.hasField('charge.CHARGE_STATE', conditions)) {
        let chargeStates = []
        const billingChargeState = await LoadDefaultQueryParam.getConfigQueryParam(
          'BillPaymentChargeState',
          ChargeConstants.CHARGE_STATES
        )
        if (billingChargeState) {
          chargeStates = LoadDefaultQueryParam.convertCommonStateToInt(
            billingChargeState
          )
          const condition = new AdvancedSearchOption(
            null,
            'charge.CHARGE_STATE',
            chargeStates,
            OperatorConstants.OPERATOR_IN.code
          )
          conditions.push(condition.formatObj2Json())
        }
      }
      // 费用确认状态
      if (!AdvancedSearchOption.hasField('charge.CONFIRM_STATE', conditions)) {
        let confirmStates = []
        const billingChargeConfirmState = await LoadDefaultQueryParam.getConfigQueryParam(
          'BillPaymentChargeConfirmState',
          ChargeConstants.CONFIRM_STATES
        )
        if (billingChargeConfirmState) {
          confirmStates = LoadDefaultQueryParam.convertCommonStateToInt(
            billingChargeConfirmState
          )
          const condition = new AdvancedSearchOption(
            null,
            'charge.CONFIRM_STATE',
            confirmStates,
            OperatorConstants.OPERATOR_IN.code
          )
          conditions.push(condition.formatObj2Json())
        }
      }
      // 是否做过付款申请
      if (defaultSearchConditions.hasBillPayment === -1) {
        const operator =
          defaultSearchConditions.hasBillPayment === -1
            ? OperatorConstants.OPERATOR_IS_NULL.code
            : OperatorConstants.OPERATOR_IS_NOT_NULL.code
        const condition = new AdvancedSearchOption(
          null,
          'charge.BILL_PAYMENT_UUID',
          null,
          operator
        )
        conditions.push(condition.formatObj2Json())
      }
      // 应收/应付
      if (defaultSearchConditions.isAr === -1) {
        const condition = new AdvancedSearchOption(
          null,
          'charge.ACCOUNT_RECEIVABLE',
          false,
          OperatorConstants.OPERATOR_EQUAL.code
        )
        conditions.push(condition.formatObj2Json())
      }
      // 是否显示  0 不勾选 1勾选已核销
      if (!this.defaultConditions.paidOff !== -1) {
        const condition = new AdvancedSearchOption(
          null,
          'charge.PAID_OFF',
          0,
          OperatorConstants.OPERATOR_EQUAL.code
        )
        conditions.push(condition.formatObj2Json())
      }

      const groups = []
      groups.push('job.UUID')
      groups.push('charge.ACCOUNT_ID')
      groups.push('charge.CURRENCY')
      const requestBody = {
        conditions,
        requires: this.requires,
        groups: groups,
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.searchConditions.job.pageNum,
        pageSize: this.searchConditions.job.pageSize,
        requestSource: 'billPayment_Create_Job'
      }
      this.queryChargeForJobConditions = conditions
      queryJobPageableFast(requestBody)
        .then((res) => {
          console.log(res)
          this.JobChargeRowData = res.data.list
          this.searchConditions.job.total = Number(res.data.total)
        })
        .finally(() => {
          this.loading.close()
        })
    },
    enterEvent() {
      // 确定事件
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectCharges'))
        return
      }
      this.$emit('addBillChargeCallBackEvent', chooseRows)
    },
    // 查询方式 切换事件 按费用 按业务
    changeQueryType(obj) {
      if (Number(obj) === 1) {
        this.queryType = 1
        this.showByChargeList = true
        this.showByJobList = false
      } else {
        this.queryType = 2
        this.showByChargeList = false
        this.showByJobList = true
      }
    },
    // 点击下一步 进入费用详情页
    nextStep() {
      console.log('start next check--------')
      // 装费用详情页数据
      const chooseRows = getGridSelected(this.gridOptions)
      if (this.queryType === 1) {
        // 按费用校验
        // 验证选中
        if (chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectCharges'))
          return
        }
        // 验证结算对象全部相同
        if (!this.isSameAccount(chooseRows)) {
          this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
          return
        }
        // 验证应收费用不能大于应付费用
        if (!this.checkBillPaymentCharge(chooseRows)) {
          this.$message.warning(this.$t('Message.ReceivableCannotMorethanPay'))
          return
        }
      } else {
        // 按业务校验
        // 验证选中
        if (chooseRows.length === 0) {
          this.$message.warning(this.$t('Message.PleaseSelectJobs'))
          return
        }
        // 验证结算对象全部相同
        if (!this.isSameAccount(chooseRows)) {
          this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
          return
        } else {
          this.loadJobCharges(this.queryChargeForJobConditions, chooseRows)
          return
        }
      }
      // 计算分单币种合计
      const currencyAmount = this.calCurrencyAmount(chooseRows)
      // 下一步
      // this.$emit('nextCreateBillPaymentCallback', chooseRows)
      this.$parent.nextCreateBillPaymentCallback(chooseRows)
    },

    // 判断费用结算对象是否相同 按业务查询
    isSameAccount(rows) {
      const chargeAccount = rows[0].chargeAccountId
      for (let i = 1; i < rows.length; i++) {
        if (chargeAccount !== rows[i].chargeAccountId) {
          return false
        }
      }
      return true
    },
    // 校验整个付款申请的金额必须是应付
    checkBillPaymentCharge(rows) {
      let c1 = 0
      let c2 = 0
      for (let i = 0; i < rows.length; i++) {
        const businessDate = !rows[i].chargeInputDate ? rows[i].chargeDateCreated : rows[i].chargeInputDate
        const localCurrency = RateUtil.localCurrencyByOfficeId(rows[i].chargeBranchId)
        if (rows[i].chargeReceivable) {
          c1 +=
            rows[i].chargeAmount *
            RateUtil.getForeignExchangeRateSafely(
              localCurrency,
              rows[i].chargeCurrency,
              businessDate, rows[i].chargeBranchId
            )
        } else {
          c2 +=
            rows[i].chargeAmount *
            RateUtil.getForeignExchangeRateSafely(
              localCurrency,
              rows[i].chargeCurrency,
              businessDate, rows[i].chargeBranchId
            )
        }
      }
      return c1 === 0 || c2 - c1 >= 0
    },
    // 遍历jobVo 所有ChargeVOList 再走一遍按费用申请
    loadJobCharges(conditions, rows) {
      // 过滤高级查询条件
      const fieldNames = ['job.UUID', 'charge.ACCOUNT_ID', 'charge.CURRENCY']
      conditions = this.filterCondition(conditions, fieldNames)
      const jobKeys = []
      for (let i = 0; i < rows.length; i++) {
        jobKeys.push(rows[i].uuid)
      }
      // 组装高级查询调价
      conditions.push(
        new AdvancedSearchOption(
          null,
          'job.UUID',
          jobKeys,
          OperatorConstants.OPERATOR_IN.code
        ).formatObj2Json()
      )
      if (!this.hasCondition(conditions, 'charge.ACCOUNT_ID')) {
        conditions.push(
          new AdvancedSearchOption(
            null,
            'charge.ACCOUNT_ID',
            rows[0].chargeAccountId,
            OperatorConstants.OPERATOR_EQUAL.code
          ).formatObj2Json()
        )
      }
      if (!this.hasCondition(conditions, 'charge.CURRENCY')) {
        const currences = this.getCurrencys(rows)
        conditions.push(
          new AdvancedSearchOption(
            null,
            'charge.CURRENCY',
            currences,
            OperatorConstants.OPERATOR_IN.code
          ).formatObj2Json()
        )
      }
      const requestBody = {
        paging: false,
        conditions,
        branchId: this.$store.getters.currentOfficeId,
        pageNum: this.searchConditions.job.pageNum,
        pageSize: this.searchConditions.job.pageSize,
        requestSource: 'billPayment_Create_Charge'
      }
      getAddChargeList(requestBody)
        .then((res) => {
          console.log('job queryChargeList = ', res)
          const charges = res.data.list
          // 验证结算对象全部相同
          if (!this.isSameAccount(charges)) {
            this.$message.warning(this.$t('Message.SettleAccountMustBeSame'))
            return
          }
          // 验证应收费用不能大于应付费用
          if (!this.checkBillPaymentCharge(charges)) {
            this.$message.warning(
              this.$t('Message.ReceivableCannotMorethanPay')
            )
            return
          }
          this.$parent.nextCreateBillPaymentCallback(res.data.list)
        })
        .finally(() => {
          this.loading.close()
        })
    },
    filterCondition(conditions, fieldNames) {
      return conditions.filter(condition => !fieldNames.includes(condition.fieldName))
    },
    // 判断高级查询条件是否包含某字段
    hasCondition(conditions, fieldName) {
      let has = false
      for (let i = 0; i < conditions.length; i++) {
        if (conditions[i].fieldName === fieldName) {
          has = true
          break
        }
      }
      return has
    },
    // 组装业务费用所有币种
    getCurrencys(jobs) {
      const currences = []
      for (let i = 0; i < jobs.length; i++) {
        if (!currences.includes(jobs[i].chargeCurrency)) {
          currences.push(jobs[i].chargeCurrency)
        }
      }
      return currences
    },
    // 计算分币种合计
    calCurrencyAmount(chooseRows) {
      let newCurrentAmount = ''
      const map = {}
      if (chooseRows.length > 0) {
        for (let i = 0; i < chooseRows.length; i++) {
          const currency = chooseRows[i].chargeCurrency
          const amount = chooseRows[i].chargeAmount
          if (!chooseRows[i].chargeReceivable) {
            if (!map.hasOwnProperty(currency)) {
              map[currency] = amount
            } else {
              map[currency] += amount
            }
          } else {
            if (!map.hasOwnProperty(currency)) {
              map[currency] = -amount
            } else {
              map[currency] += -amount
            }
          }
        }

        for (const curreny in map) {
          if (NumberUtils.formatNumber(map[curreny], 2) !== '0.00') {
            newCurrentAmount +=
              curreny + ':' + NumberUtils.formatNumber(map[curreny], 2) + ';'
          }
        }
      }
      return newCurrentAmount
    }
  }
}
</script>
<style lang="scss">
.new-bill-payment-dialog {
  .el-radio {
    margin-right: 0;
    margin-left: 10px;
  }
}
</style>
